/**
 * Generate CRCCS data for a QRCode from a list of commands
 *
 * @remarks - CRCCS is the configuration format of the data as text
 * - CRMKR is the format of the data once it is encoded into data for a QR code
 *
 * @param cmds an array of commands to be included in the CRCCS string
 * @returns a string suitable for encoding into a QR code
 */
export const crccs = (cmds: string[]) => {
    if (cmds.length === 0) throw new Error('No commands provided')
    return `\x01Y\x1d\x02${cmds.join('\x03')}\x03\x04`
}
export const processCrccsFile = (content: string) => {
    //Split the content into lines
    const lines = content.split('\n')

    //Filter out lines that are comments or empty
    const cleanedLines = lines
        .filter((line) => line.trim() !== '' && !line.trim().startsWith('//'))
        .map((line) => line.split('//')[0]?.trim()) // Remove comments from the end of each line

    //Join the cleaned lines with a semicolon
    const result = cleanedLines.join('; ')
    return result
}
